import { render, staticRenderFns } from "./documentCirculation.vue?vue&type=template&id=32ab74aa&"
import script from "./documentCirculation.vue?vue&type=script&lang=js&"
export * from "./documentCirculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ab74aa')) {
      api.createRecord('32ab74aa', component.options)
    } else {
      api.reload('32ab74aa', component.options)
    }
    module.hot.accept("./documentCirculation.vue?vue&type=template&id=32ab74aa&", function () {
      api.rerender('32ab74aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/documentCirculation.vue"
export default component.exports